import { RequestState } from '@modules/external-services/omc-management/store/omc-management.state';
import {
  GqlResponse
} from '@shared/graphql-response/graphql.response';
import {
  SarimaPredictData,
  PredictAllData,
  SarimaRetrainData,
  SarimaRetrainAllData,
  SarimaIngestImportsData,
  SarimaHealthData,
  SarimaModelsData,
  SarimaModelRunsData,
  ModelRun,
  SarimaImportsData,
  SarimaChartData,
  SarimaForecastByIdData,
  SarimaTestPredictionsData,
} from '../responses/smart-forecasting.response';

export interface SmartForecastingState {
  sarimaPredict: RequestState<GqlResponse<SarimaPredictData>>;
  predictAll: RequestState<GqlResponse<PredictAllData>>;
  sarimaRetrain: RequestState<GqlResponse<SarimaRetrainData>>;
  sarimaRetrainAll: RequestState<GqlResponse<SarimaRetrainAllData>>;
  sarimaIngestImports: RequestState<GqlResponse<SarimaIngestImportsData>>;
  sarimaHealth: RequestState<GqlResponse<SarimaHealthData>>;
  sarimaModels: RequestState<GqlResponse<SarimaModelsData>>;
  sarimaModelRuns: RequestState<GqlResponse<SarimaModelRunsData>>;
  sarimaModelRunById: RequestState<GqlResponse<ModelRun>>;
  sarimaLatestModelRun: RequestState<GqlResponse<ModelRun>>;
  sarimaImports: RequestState<GqlResponse<SarimaImportsData>>;
  sarimaImportSummary: RequestState<GqlResponse<SarimaImportsData>>;
  sarimaLatestChartData: RequestState<GqlResponse<SarimaChartData>>;
  sarimaForecastById: RequestState<GqlResponse<SarimaForecastByIdData>>;
  sarimaChartDataById: RequestState<GqlResponse<SarimaChartData>>;
  sarimaTestPredictions: RequestState<GqlResponse<SarimaTestPredictionsData>>;
  sarimaUploadImports: RequestState<GqlResponse<SarimaIngestImportsData>>;
}

const baseState = { loading: false, response: null, error: null, message: null };

export const initialSmartForecastingState: SmartForecastingState = {
  sarimaPredict: { ...baseState },
  predictAll: { ...baseState },
  sarimaRetrain: { ...baseState },
  sarimaRetrainAll: { ...baseState },
  sarimaIngestImports: { ...baseState },
  sarimaHealth: { ...baseState },
  sarimaModels: { ...baseState },
  sarimaModelRuns: { ...baseState },
  sarimaModelRunById: { ...baseState },
  sarimaLatestModelRun: { ...baseState },
  sarimaImports: { ...baseState },
  sarimaImportSummary: { ...baseState },
  sarimaLatestChartData: { ...baseState },
  sarimaForecastById: { ...baseState },
  sarimaChartDataById: { ...baseState },
  sarimaTestPredictions: { ...baseState },
  sarimaUploadImports: { ...baseState },
};
